export const classes = {
  form: 'flex flex-col',
  heading: 'mb-[34px]',
  email: 'mb-[44px]',
  backWrapper: 'mt-[22px] flex justify-center',
};
